/*
 * @Author: shannyHuang
 * @Date: 2022-03-25 17:55:28
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2022-03-29 18:05:12
 * @FilePath: /wemeet-web-activity/src/components/HomeHeader/use-share.ts
 */
import { useRouter } from 'next/router';

export const useShareUrl = (hostId?: string | number, homePage?: boolean) => {
  const { basePath, query } = useRouter();
  let qrCodeUrl = basePath;
  if (typeof window !== 'undefined') {
    qrCodeUrl = `${window.location.origin + basePath}/space${homePage ? '/share' : ''}?host_id=${
      hostId || query.hostId || query.host_id
    }${homePage ? '&fromPage=share-homepage' : ''}`;
  }
  return qrCodeUrl;
};
